<template>
  <v-card-actions>
    <template v-if="finalizado">
      <v-spacer></v-spacer>
      <template v-if="validacaoObrigatoria && statusValidacao !== 'aprovado'">
        <v-btn color="info" class="text-capitalize" rounded depressed>
          Processando documento
        </v-btn>
      </template>
      <template v-else>
        <v-btn @click="linkAso()" target="_blank" color="success" class="text-capitalize" rounded depressed>ASO</v-btn>
      </template>
      <v-btn
        @click="fichaClinica ? $emit('open-ficha-clinica') : linkFichaClinica()"
        target="_blank"
        color="success"
        class="text-capitalize"
        rounded
        depressed
        >Ficha Clínica</v-btn
      >
    </template>
    <template v-else>
      <template v-if="!fichaPreenchida">
        <v-spacer></v-spacer>
        <v-btn
          @click="handlePreencherFichaClinica"
          class="primary--text text-capitalize"
          color="tertiary"
          rounded
          depressed
          :loading="loadingDadosContato"
        >
          Preencher Ficha Clínica</v-btn
        >
      </template>
      <template v-else-if="!assinatura">
        <v-spacer></v-spacer>
        <v-btn
          @click="$router.push({ name: 'assinatura' })"
          class="primary--text text-capitalize"
          color="tertiary"
          rounded
          depressed
        >
          Preencher Assinatura</v-btn
        >
      </template>
      <template v-else-if="fichaPreenchida">
        <p class="success--text font-weight-bold subtitle-2 ml-5">
          Ficha Clínica Preenchida
        </p>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('on-click')" class="warning--text text-capitalize" color="#fff1de" rounded depressed>
          <v-icon left>mdi-pencil</v-icon>Editar
        </v-btn>
      </template>
    </template>

    <ConfirmarDadosContatoDialog
      v-if="showDadosContatoDialog"
      v-model="showDadosContatoDialog"
      @dados-confirmados="$emit('on-click')"
    />
  </v-card-actions>
</template>

<script>
import documentsUrlsMixins from '@/core/mixins/documentsUrlsMixins'
import Axios from 'axios'
import userService from '@/services/user'
import ConfirmarDadosContatoDialog from '@/modules/Agendamento/dialogs/ConfirmarDadosContatoDialog'

export default {
  mixins: [documentsUrlsMixins],
  components: {
    ConfirmarDadosContatoDialog
  },
  props: [
    'finalizado',
    'arquivoRetorno',
    'imprimirGuia',
    'idAso',
    'fichaPreenchida',
    'fichaClinica',
    'idLinkAso',
    'assinatura',
    'validacaoObrigatoria',
    'statusValidacao'
  ],
  data() {
    return {
      showDadosContatoDialog: false,
      loadingDadosContato: false
    }
  },
  computed: {
    plataformaUrl() {
      return process.env.VUE_APP_PLATAFORMA_URL
    }
  },
  methods: {
    async handlePreencherFichaClinica() {
      try {
        this.loadingDadosContato = true
        const { data } = await userService.verificaDadosContato()

        if (data.preencheuDados) {
          this.$emit('on-click')
        } else {
          this.showDadosContatoDialog = true
        }
      } catch ({ response }) {
        this.$showErrorMessage(response?.data?.message || 'Erro ao verificar dados')
      } finally {
        this.loadingDadosContato = false
      }
    },
    async linkFichaClinica() {
      window.open(`${this.plataformaUrl}/aso/${encodeURIComponent(this.idLinkAso)}/ficha-clinica`)
    },
    async linkAso() {
      const { data } = await Axios.get(`${this.plataformaUrl}/asos/${this.idAso}/arquivo-retorno/download`)
      window.open(data.arquivo)
    }
  }
}
</script>

<style></style>
